import { ArrangementType, Cultures, PaperRate } from '../../ecg-viewer-module/models/enums';
import { ECG_CONSTANTS } from '../../ecg-viewer-module/utils/ecg-constants';

export enum DeviceLayout {
    auto = 0,
    desktop = 1,
    mobile = 2,
}

export class ReadDetection<T> {
    // data members

    constructor(defaultValue: T) {
        this._value = defaultValue;
    }

    private _read: boolean = false;

    get read() {
        return this._read;
    }

    private _value: T;

    get value() {
        return this._value;
    }

    // constructor

    set value(value) {
        this._value = value;
        this._read = true;
    }
}

export class LayoutConfiguration {
    arrangement: ReadDetection<ArrangementType> = new ReadDetection<ArrangementType>(ArrangementType.SixXTwo);
    paperRate: ReadDetection<PaperRate> = new ReadDetection<PaperRate>(PaperRate.mm25);
    paperOpacity: ReadDetection<number> = new ReadDetection<number>(ECG_CONSTANTS.PAPER_OPACITY);
}

export class CustomCommandConfiguration {
    visible: ReadDetection<boolean> = new ReadDetection<boolean>(false);
    text: ReadDetection<string> = new ReadDetection<string>('');
    source: ReadDetection<string> = new ReadDetection<string>('');
}

export class EcgConfiguration {
    culture: ReadDetection<Cultures> = new ReadDetection<Cultures>(Cultures.it_IT);
    detailsvisible: ReadDetection<boolean> = new ReadDetection<boolean>(true);
    deviceLayout: ReadDetection<DeviceLayout> = new ReadDetection<DeviceLayout>(DeviceLayout.auto);

    layoutConfiguration!: LayoutConfiguration;
    customCommandConfiguration!: CustomCommandConfiguration;
}
